<template>
  <div class="container head-container">
    <div class="header-section d-flex align-items-center justify-content-center">
      <div class="header-logo d-flex align-items-center">
        <h2>
          <img src="../assets/images/bloom_logo.svg" style="width:100%; height:100%"/>
        </h2>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center body-content">
      <div class="text-center content-wrapper">
        <p class="font-24 mb-5 font-weight-bold">
          企業登録が完了しました！
        </p>
        <p class="font-18 mb-5 description-text">
          マイページでは、<br />
          大手企業の求人を閲覧できます。
        </p>
        <div class="image-container mb-5">
          <img :src="completeImage" alt="Complete" class="complete-image" />
        </div>
        <button
          class="btn btn-cstm btn-cstm-primary"
          @click="handleOkClick"
          :disabled="isLoadingProfile"
          data-testid="navigate-to-mypage-button"
        >
          マイページへ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex';
import completeImage from '../assets/images/complete.svg';

export default {
  name: 'CompanyRegistrationComplete',
  data() {
    return {
      completeImage: completeImage,
      isLoadingProfile: true
    };
  },
  computed: {
    ...mapGetters({ profile: 'getProfile'})
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile',
    }),
    handleOkClick() {
      if(!this.profile.company_scout_profile){
        return this.$router.push('/job-listings');
      }
      this.$router.push('/');
    },
  },
  async created() {
    await this.setProfile();
    this.isLoadingProfile = false;
  }
};
</script>

<style scoped>
.content-wrapper {
  max-width: 600px;
  width: 100%;
  padding: 0 20px;
}

.body-content {
  min-height: 75vh;
  padding-top: 50px;
}

.btn-cstm {
  padding: 12px 20px;
  width: 100%;
  max-width: 350px;
  border-radius: 4px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
  background-color: #076d6c !important;
  border-color: #076d6c !important;
}

.btn-cstm:hover {
  background-color: #065a59 !important;
}

.font-24 {
  font-size: 28px;
}

.font-18 {
  font-size: 18px;
}

.description-text {
  font-weight: 600;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.complete-image {
  max-width: 200px;
  width: 100%;
  height: auto;
}

.header-section {
  padding: 50px 0 20px;
  margin-bottom: 0;
}

.header-logo h2 {
  margin: 0;
}

.header-logo img {
  max-width: 400px;
}

@media (max-width: 768px) {
  .body-content {
    padding-top: 40px;
  }

  .header-section {
    justify-content: flex-start !important;
    padding-left: 20px;
  }

  .header-logo img {
    max-width: 250px;
  }

  .font-24 {
    font-size: 20px;
  }

  .font-18 {
    font-size: 16px;
  }

  .complete-image {
    max-width: 200px;
  }

  .btn-cstm {
    max-width: 300px;
  }
}
</style> 